jQuery(document).ready(function () {
    console.log('is_cms_lancelot: ' + is_lancelot);

    /*****
     * smartresize when resize screen
     *****/
    _window.smartresize(function () {
        /* re-calc viewport Width & Height */
        viewportW = _window.width();
        viewportH = _window.height();
    });

    /* unwrap container on lancelot */
    var template_1 = jQuery('.template_1');
    if (template_1.length > 0) {
        jQuery('.template_1_m').unwrap();
        jQuery('#header').unwrap();
        jQuery('#footer').unwrap();
    }

    /* menu smp */
    var header_scroll_class = '_small';

    /* header small */
    jQuery(window).on('scroll', function (e) {
        if (jQuery(window).scrollTop() > 100)
            jQuery('#header').addClass(header_scroll_class);
        else jQuery('#header').removeClass(header_scroll_class);
    });

    /*! scroll to top !*/
    jQuery('body').toTopButton({
        imagePath: path_media + 'icons',
        arrowType: 'scroll-top',
        margin: 2,
        size: is_smp ? 4 : 7,
        backgroundColor: 'transparent',
        linkClasses: ['scroll_totop'],
        mobileHide: 0
    });

    /*! zoom img on SMP !*/
    var smp_zoom = jQuery('.smp_zoom');
    if (smp_zoom.length > 0 && viewportW <= viewportSMP) {
        smp_zoom.each(function () {
            jQuery(this).wrap('<a data-fancybox href="' + jQuery(this).attr('src') + '"></a>');
        });
    }

    /* check element in view */
    var in_view = jQuery('[class*="inview-"]');
    if (in_view.length > 0) {
        in_view.on('inview', function (event, isInView) {
            if (isInView)
                jQuery(this).addClass('inview-active');
        });
    }

    /* fancybox */
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });


    /* menu */
    var menu_smp = jQuery('.hamburger');
    menu_smp.on('click', function () {
        jQuery(this).toggleClass('is-active');
        jQuery('#header').toggleClass('is-open');
        jQuery(this).parents('.head_group_right').next().fadeToggle(300);
    });

    jQuery('.global_navi ._trigger').on('click', function (e) {
        e.preventDefault();
        jQuery(this).toggleClass('is-open');
        jQuery(this).next().slideToggle(200);
    });

    /* main visual */
    setTimeout(function () {
        var main_visual = jQuery('.main_visual.banner_image');
        if (main_visual.length > 0) {
            // background image
            var mainvisual_image = is_smp ? main_visual.data('imgsmp') : main_visual.data('imgpc');
            main_visual.css('background-image', 'url(' + mainvisual_image + ')');
        }
    }, 500);

    /* WOW */
    new WOW().init();

    /* zipcode to address */
    if (jQuery('.form__detail .zipcode').length > 0 && !is_lancelot) {
        jQuery('.form__detail .zipcode').zip2addr({
            addr: '.form__detail .address'
        });
    }

    /* Get type application / 応募種別 */
    if (jQuery('.entryform__input').length > 0) {
        var application_type = parseInt(window.location.href.split('application_type=')[1]);
        if (application_type == 1)
            jQuery('input[type="radio"][value="新卒採用"]').prop('checked', true);
        if (application_type == 2)
            jQuery('input[type="radio"][value="中途採用"]').prop('checked', true);
    }

    /* checkbox button submit / 個人情報の取り扱いに「同意する」 */
    jQuery('#form__agree_check').prop('checked', false);
    jQuery('#form__agree_check').click(function () {
        if (jQuery(this).is(':checked')) {
            jQuery('.form__agree_submit').removeAttr('disabled');
        } else {
            jQuery('.form__agree_submit').attr('disabled', 'disabled');
        }
    });

    /* auto fill data select date | year */
    var select_data__years = jQuery('.select_data__years');
    if (select_data__years.length > 0 && !is_lancelot) {
        select_data__years.each(function () {
            var _date = new Date();
            var _year_current = parseInt(_date.getFullYear());
            var _length = 100;
            var _this_option = '<option value="">—</option>';
            while (_length >= 0) {
                _this_option += '<option value="' + _year_current + '">' + _year_current + '</option>';
                _year_current--;
                _length--;
            }
            jQuery(this).html(_this_option);
        });
    }

    /* auto fill data select date | month */
    var select_data__months = jQuery('.select_data__months');
    if (select_data__months.length > 0 && !is_lancelot) {
        select_data__months.each(function () {
            var _this_option = '<option value="">—</option>';
            for (var i = 1; i <= 12; i++)
                _this_option += '<option value="' + i + '">' + i + '</option>';
            jQuery(this).html(_this_option);
        });
    }

    /* auto fill data select date | day */
    var select_data__days = jQuery('.select_data__days');
    if (select_data__days.length > 0 && !is_lancelot) {
        select_data__days.each(function () {
            var _this_option = '<option value="">—</option>';
            for (var i = 1; i <= 31; i++)
                _this_option += '<option value="' + i + '">' + i + '</option>';
            jQuery(this).html(_this_option);
        });
    }

    /* common bottom slider */
    if (jQuery('.common_bottom_slider').length > 0) {
        const common_bottom_slider = new Swiper('.common_bottom_slider .swiper', {
            spaceBetween: 12,
            slidesPerView: 1,
            centeredSlides: true,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
            },

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            scrollbar: {
                el: '.swiper-scrollbar',
            },
            breakpoints: {
                801: {
                    slidesPerView: 3,
                    spaceBetween: 25,
                    centeredSlides: false,
                    loop: false,
                }
            }
        });
    }

});


